// polyfills
import './polyfills/dom';

// bootstrap components
import './components/bootstrap-components';

// components
import './components/links';
import './components/diagonal-pictures';
import './components/mobile-mega-menu';
// import './components/service-search';
import './components/sticky-header';
import './components/swiper';
import './components/service-hero-video';
import './components/holiday-schedule';
import './components/curb-to-grid';
import './components/GTM';

import { ScrollAnimations } from './components/scroll-animations';

ScrollAnimations.InitScrollTriggerForAnimateCSS();
ScrollAnimations.InitTweenAnimations();

import { tables_AutoCalculateOddRow } from './components/tables';
tables_AutoCalculateOddRow();

import type { SvelteComponent } from 'svelte';
import { attributesToObject } from './utilities/ElementHelpers';
import HolidayScheduleLocator, { selector as HolidayScheduleLocatorSelector } from './svelte/HolidayScheduleLocator/HolidayScheduleLocator.svelte';
import SustainabilityCalculator, { selector as SustainabilityCalculatorSelector } from './svelte/SustainabilityCalculator/SustainabilityCalculator.svelte';
import FindServiceForm, { selector as FindServiceFormSelector } from './svelte/FindServiceForm/FindServiceForm.svelte';
import LocalCityServicesBlock, { selector as LocalCityServicesBlockSelector } from './svelte/LocalCityServicesBlock/LocalCityServicesBlock.svelte';

const ComponentMap: { [key: string]: typeof SvelteComponent } = {
    [HolidayScheduleLocatorSelector]: HolidayScheduleLocator,
    [SustainabilityCalculatorSelector]: SustainabilityCalculator,
    [FindServiceFormSelector]: FindServiceForm,
    [LocalCityServicesBlockSelector]: LocalCityServicesBlock
};
for (const selector in ComponentMap) {
    // initiate svelte components
    [...document.querySelectorAll<HTMLElement>(selector)].forEach(el => {
        const componentClass = ComponentMap[selector];
        new componentClass({
            target: el,
            props: attributesToObject(el)
        });
    });
}
